export default __webpack_public_path__ + "static/media/closeSmall.65d54a74.svg";